// extracted by mini-css-extract-plugin
module.exports = {"logo":"g-logo_logo_2oxCP","title":"g-logo_title_2JEUL","dark":"g-logo_dark_1bvJ6","subtitle":"g-logo_subtitle_h-R_J"};